__turbopack_context__.v({
  "blogTable": "TablePrimary-module__3hqLbG__blogTable",
  "roundedTable": "TablePrimary-module__3hqLbG__roundedTable",
  "scrollHint": "TablePrimary-module__3hqLbG__scrollHint",
  "scrollHintLeft": "TablePrimary-module__3hqLbG__scrollHintLeft",
  "scrollHintRight": "TablePrimary-module__3hqLbG__scrollHintRight",
  "table": "TablePrimary-module__3hqLbG__table",
  "tableHeader": "TablePrimary-module__3hqLbG__tableHeader",
  "tableScroll": "TablePrimary-module__3hqLbG__tableScroll",
});
